import { cn } from '@lib/utils';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  placeholder?: string;
  leftNode?: React.ReactNode;
  rightNode?: React.ReactNode;
  className?: string;
  inputClassName?: string;
}

function Input({
  placeholder = 'Search',
  leftNode,
  rightNode,
  className,
  inputClassName,
  ...props
}: InputProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-3 rounded-lg border-3b-text-hint bg-white focus-within:ring-2 focus-within:ring-blue-500',
        className,
      )}
    >
      {leftNode}
      <input
        type="text"
        placeholder={placeholder}
        className={cn('w-full text-black focus:outline-none', inputClassName)}
        {...props}
      />
      {rightNode}
    </div>
  );
}

export default Input;
